/* eslint max-classes-per-file: 0 */

import {
  Mark as Data,
  MarkCollection as Collection,
} from '@/typings/api/Marks'

import { BaseMarksApiAuth } from '@/api/BaseApiAuth'
import {
  BaseApiParams,
  BaseApiResponse,
  CollectionMeta,
} from '@/typings/common'
import { AxiosRequestConfig } from 'axios'

export class VeersApi extends BaseMarksApiAuth<Data, Collection> {
  protected readonly endpoint = 'veers';

  protected readonly hasFinishSlash = false;

  public upload(p: BaseApiParams, config?: AxiosRequestConfig) {
    const path = 'upload'
    const data = new FormData()
    // eslint-disable-next-line no-restricted-syntax
    for (const [key, val] of Object.entries(p)) {
      if (['string', 'boolean'].includes(typeof val)) {
        data.append(key, val as string)
      } else if (!!val && typeof val === 'object') {
        data.append(key, val as Blob)
      }
    }
    data.append('procedure_id', String(p.procedure_id))
    const [url] = this.getUrl(path)
    return this.request<never, BaseApiResponse<Data, CollectionMeta>>(
      'POST',
      url,
      { data, ...config },
    )
  }

  public generate(procedure_id: string, config?: AxiosRequestConfig) {
    const path = 'generate'
    const data = { procedure_id }
    const [url] = this.getUrl(path)
    return this.request<never, BaseApiResponse<Data, CollectionMeta>>(
      'POST',
      url,
      { data, ...config },
    )
  }
}
